import { FC, HTMLAttributes } from 'react'
import clsx from 'clsx'

const Card: FC<HTMLAttributes<HTMLDivElement>> = ({ children, className }) => (
  <div
    className={clsx(
      'rounded bg-gray-50 shadow-xl w-full',
      className
    )}
  >
    {children}
  </div>
)

export default Card
